import { PropsWithChildren, useEffect, useState } from "react";
import { OverlayEvent } from "@features/onsiteEshop/utils/types";
import { CustomEventEnum } from "@typings/CustomEvent";

/**
 * Display BT components when eshop send overlay:deprioritize event or default to true if no event is sent.
 * Doc: https://sph.atlassian.net/wiki/spaces/CHB/pages/2212954211/Onsite+Checkout+Integration+Guide#4.2.-Handling-of-overlay:prioritize-and-overlay:deprioritize
 */
const EshopOverlayVisibilityGate = ({
  children,
}: PropsWithChildren): React.ReactElement => {
  const [isBTComponentsVisible, setBTComponentsVisible] = useState(true);

  const handleOverlayPrioritize = ({ detail }: OverlayEvent) => {
    if (!detail.id) return;

    if (detail.id === "eshop-onsite-checkout") {
      setBTComponentsVisible(false);
    }
  };

  const handleOverlayDeprioritize = ({ detail }: OverlayEvent) => {
    if (!detail.id) return;

    if (detail.id === "eshop-onsite-checkout") {
      setBTComponentsVisible(true);
    }
  };

  useEffect(() => {
    if (typeof window === "undefined") return;

    const listeners = window.addEventListener;

    listeners(CustomEventEnum.OverlayPrioritize, handleOverlayPrioritize);
    listeners(CustomEventEnum.OverlayDeprioritize, handleOverlayDeprioritize);

    return () => {
      const removeListeners = window.removeEventListener;

      removeListeners(
        CustomEventEnum.OverlayPrioritize,
        handleOverlayPrioritize
      );

      removeListeners(
        CustomEventEnum.OverlayDeprioritize,
        handleOverlayDeprioritize
      );
    };
  }, []);

  if (!isBTComponentsVisible) return <></>;

  return <>{children}</>;
};

export default EshopOverlayVisibilityGate;
